import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContenedorBoton } from '../componentes_generales/componentes_formulario/contenedores';
import { LabelForm, LabelRadio, LabelNota } from '../componentes_generales/componentes_formulario/labels';
import TreeNode from '../componentes_generales/componentes_formulario/treeNodeCtaContable/treeNode';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import global_axios from '../../funciones_globales/interaccionapi';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { cargar_CuentasbyPlanContable, cargar_PlanesContables, seleccionar_CuentaContable, inicializar_Cuentas } from '../../actions/contabilidad/act_con02';
import { validarCampoString, validarPermisoAcceso } from '../../funciones_globales/utils';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

const ContenedorCatalogo = styled.div`  
  background-color: #fcfcfc;
  border: 1px solid #cfd8dc;
  border-radius: 5px;
  height: 400px;
  overflow: auto;
  padding: 10px 20px;
`;

const RegExpMascaraPlanNiif = [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/];
const RegExpMascaraPlanNec = [/[1-9]/, '.', /[1-9]/, '.', /[1-9]/, '.', /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/];

class FormCon08 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      operacion: 'M',
      planContable_sel: '001',
      editarIdentificadorGrupo: false      
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.cargarCuentasByPlanContable = this.cargarCuentasByPlanContable.bind(this);
    this.imprimirPlanCuentas = this.imprimirPlanCuentas.bind(this);
    this.guardarCuentaContable = this.guardarCuentaContable.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if(name==='Cuenta' || name==='Nombre' || name==='Imputable' || name==='Balance' || name==='Orden'){
      let cuentaContableSel = {...this.props.cuentaContable, [name]: value};
      this.props.seleccionar_CuentaContable(cuentaContableSel);
    }else{
      this.setState({
        [name]: value
      });
    }
  }
  
  componentDidMount(){
    this.props.generar_LogAuditoriaIngresoForm('0808');
    this.props.cargar_PlanesContables();
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0808');
  }

  cargarCuentasByPlanContable(){
    if (!validarCampoString(this.state.planContable_sel, 3)){
      alert('No ha seleccionado un Plan Contable.');
      return;
    }

    this.props.cargar_CuentasbyPlanContable(this.state.planContable_sel);
  }

  limpiar(){
    this.setState({
      planContable_sel: '001',
      editarIdentificadorGrupo: false   
    });

    this.props.seleccionar_CuentaContable({});
    this.props.inicializar_Cuentas();
  }

  imprimirPlanCuentas(){
    try {
      if(!validarCampoString(this.state.planContable_sel, 3)){
        alert('No ha seleccionado el Plan Contable que desea imprimir.');
        return;
      }
  
      let urlReportWithParams=`&rpt=93&param1=${this.state.planContable_sel}`;
      visualizarReporteEnPdf(urlReportWithParams);  
    } catch (error) {
      alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
    }
  }

  guardarCuentaContable(){

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    if(!validarCampoString(this.state.planContable_sel, 3)){
      alert('No ha especificado correctamente el Plan Contable');
      return;
    }

    let cuentaContable = this.props.cuentaContable;

    if(!validarCampoString(cuentaContable.Cuenta, 2, 17)){
      alert('No ha especificado correctamente la Cuenta.');
      return;
    }

    if(!validarCampoString(cuentaContable.Nombre, 2, 150)){
      alert('No ha especificado correctamente el Nombre de la Cuenta.');
      return;
    }

    if(!validarCampoString(cuentaContable.Imputable, 1)){
      alert('No ha especificado correctamente el Tipo de Cuenta.');
      return;
    }

    let numeroCuentaCtble = cuentaContable.Cuenta;
    if(numeroCuentaCtble.indexOf('_') !== -1){
      numeroCuentaCtble = numeroCuentaCtble.substring(0, numeroCuentaCtble.indexOf('_')-1);
    }

    if(this.state.planContable_sel==='001'){
      if(numeroCuentaCtble.length===2 && (!validarCampoString(cuentaContable.Balance, 1))){
        alert('Debe especificar el Identificador de Grupo.');
        this.setState({editarIdentificadorGrupo: true});
        return;
      }
    }else{
      if(this.state.planContable_sel==='000'){
        if(numeroCuentaCtble.length===1 && (!validarCampoString(cuentaContable.Balance, 1))){
          alert('Debe especificar el Identificador de Grupo.');
          this.setState({editarIdentificadorGrupo: true});
          return;
        }
      }
    }
    
    let fechaProceso = getFechaProcesoPorModulo('08');
        
    let dataCuentaContable = {
      planCuenta: this.state.planContable_sel,
      cuenta: numeroCuentaCtble,
      fechaIngreso: fechaProceso,
      nombre: cuentaContable.Nombre,
      esImputable: cuentaContable.Imputable,
      balance: cuentaContable.Balance
    };

    this.props.cambiar_VisualizacionLoading(true);        
    global_axios({
      method: 'PUT',
      url: `/cuentas/${this.state.planContable_sel}/${numeroCuentaCtble}`,
      data: dataCuentaContable
    })
    .then((response)=>{
      this.props.cambiar_VisualizacionLoading(false);
      this.cargarCuentasByPlanContable();
      alert('Se guardó correctamente la Cuenta No.: ' + response.data.cuentaCtble.cuenta);      
    })
    .catch(error => {
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  render(){
    let catalogoCuentas = this.props.catalogoCuentas.map((node) => {
      return (
        <TreeNode key={node.Id} datosCta={node}/>)
    });

    let planesContables = this.props.planesContables.map(item => ({value: item.PlanCuenta.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.PlanCuenta.toString().toUpperCase()})` }));

    return(
      <ContenedorForm porc_ancho={80}>
        <HeaderForm>
          <TituloForm>Plan de Cuentas Contables</TituloForm>
        </HeaderForm>
        <CuerpoForm>
          <Row>
            <ContainerCol className='col-sm-5' margen_arriba={5}>
              <LabelForm>Plan Contable:</LabelForm>
              <ReactSelect options={ planesContables } value={this.state.planContable_sel}
                func_onChange={(value)=>{if(Array.isArray(value)){value=null;} this.setState({planContable_sel: value!==null?value.value:null})}}
                func_onFocus={this.limpiar}
              />
            </ContainerCol>
            <ContainerCol className='col-sm-1' margen_arriba={5}>
              <ContenedorBoton margen_arriba={20}>
                <Tooltip placement='right' overlay='Cargar cuentas del Plan Contable seleccionado.'>
                  <button type='button' className='btn btn-success btn-sm' onClick={this.cargarCuentasByPlanContable}><i className='fa fa-search'></i></button>
                </Tooltip>
              </ContenedorBoton>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-8'>
            <Row>
              <ContainerCol className='col-sm-12' margen_arriba={20}>
                <ContenedorCatalogo>
                  {catalogoCuentas}
                </ContenedorCatalogo>
              </ContainerCol>
            </Row>
            <Row>
              <ContainerCol className='col-sm-12'>
                <LabelNota>Si desea seleccionar una cuenta haga clic sobre ella.</LabelNota>               
              </ContainerCol>
            </Row>
            </ContainerCol>
            <ContainerCol className='col-sm-4' margen_arriba={20}>
              <Row>
                <ContainerCol className='col-sm-6'>
                  <LabelForm>Cuenta:</LabelForm>
                  <MaskedInput autoComplete='off' name='Cuenta' value={this.props.cuentaContable===null?'':this.props.cuentaContable.Cuenta?this.props.cuentaContable.Cuenta:''} className='form-control input-sm'
                    mask={this.state.planContable_sel==='000'?RegExpMascaraPlanNec:RegExpMascaraPlanNiif}
                    onChange={this.handleInputChange}
                    maxLength='150'
                    onFocus={()=>{this.props.seleccionar_CuentaContable({})}}
                    />
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <LabelForm>Nombre:</LabelForm>
                  <InputText autoComplete='off' name='Nombre' value={this.props.cuentaContable===null?'':this.props.cuentaContable.Nombre?this.props.cuentaContable.Nombre:''} type='text' className='form-control input-sm' onChange={this.handleInputChange}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <LabelForm>Tipo:</LabelForm>
                  <div>
                    <LabelRadio className='radio-inline'>
                      <input type="radio" name="Imputable" value="N" checked={this.props.cuentaContable===null?false:this.props.cuentaContable.Imputable==="N"} onChange={this.handleInputChange}/>
                      Cuenta Grupal
                    </LabelRadio>
                    <LabelRadio className='radio-inline'>
                      <input type="radio" name="Imputable" value="S" checked={this.props.cuentaContable===null?false:this.props.cuentaContable.Imputable==="S"} onChange={this.handleInputChange}/>
                      Cuenta con Movimiento
                    </LabelRadio>
                  </div>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-6'>
                  <LabelForm>Identificador Grupo:</LabelForm>
                  <InputText autoComplete='off' name='Balance' value={this.props.cuentaContable===null?'':this.props.cuentaContable.Balance?this.props.cuentaContable.Balance:''} 
                    type='text' className='form-control input-sm' onChange={this.handleInputChange} maxLength='1' mayusculas={true} readOnly={!this.state.editarIdentificadorGrupo}/>
                </ContainerCol>
                <ContainerCol className='col-sm-6'>
                  <LabelForm>Orden:</LabelForm>
                  <InputText autoComplete='off' name='Orden' value={this.props.cuentaContable===null?'':this.props.cuentaContable.Orden?this.props.cuentaContable.Orden:''}
                    type='number' className='form-control input-sm' min='1' onChange={this.handleInputChange} readOnly={true}/>
                </ContainerCol>
              </Row>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12' margen_arriba={15}>
              <div className='btn-group pull-right'>
                <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarCuentaContable}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirPlanCuentas}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>                
              </div>
            </ContainerCol>
          </Row>
        </CuerpoForm>
      </ContenedorForm>
    );
  }
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            catalogoCuentas: state.contabilidad.catalogoCuentas,
            planesContables: state.contabilidad.planesContables,
            cuentaContable: state.contabilidad.cuentaContable
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm,
                              cambiar_VisualizacionLoading,
                              cargar_CuentasbyPlanContable,
                              cargar_PlanesContables,
                              seleccionar_CuentaContable,
                              inicializar_Cuentas                                     
                             }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCon08);